module.exports = __webpack_public_path__ + "static/media/boom-hout.153a7009.png";